/** Upload de fișier: presign → PUT (prin proxy /media) → confirm. */
import { presignFile, confirmFile } from '../api/endpoints';
import { resolveMediaUrl } from './media';
import type { FileItem } from '../api/types';

/** Extrage dimensiunile unei imagini pentru confirm (best-effort). */
function imageDimensions(file: File): Promise<{ width?: number; height?: number }> {
  if (!file.type.startsWith('image/')) return Promise.resolve({});
  return new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
      URL.revokeObjectURL(url);
    };
    img.onerror = () => {
      resolve({});
      URL.revokeObjectURL(url);
    };
    img.src = url;
  });
}

export async function uploadFile(file: File): Promise<FileItem> {
  const presigned = await presignFile({ filename: file.name, mime: file.type || 'application/octet-stream', size: file.size });
  const putUrl = resolveMediaUrl(presigned.uploadUrl) ?? presigned.uploadUrl;
  const res = await fetch(putUrl, {
    method: presigned.method || 'PUT',
    body: file,
    headers: { 'Content-Type': presigned.mime },
  });
  if (!res.ok) throw new Error(`Încărcarea a eșuat (${res.status})`);
  const dims = await imageDimensions(file);
  return confirmFile(presigned.fileId, dims);
}
